export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20atmospheric%20abstract%20background%20with%20warm%20deep%20red%20and%20dark%20charcoal%20gradient%20tones%2C%20subtle%20texture%20patterns%2C%20mysterious%20and%20intense%20mood%2C%20digital%20news%20media%20aesthetic%2C%20no%20text%2C%20cinematic%20lighting%2C%20professional%20editorial%20style&width=1800&height=1200&seq=hero-bg-911&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></span>
              <span className="text-xs font-medium text-background-50 tracking-wide">
                实时更新 · 全网最热吃瓜入口
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
              911爆料网
              <br />
              <span className="text-primary-300">一站式吃瓜黑料内容聚合平台</span>
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 mb-4 font-light leading-relaxed">
              汇聚全网最全最新的吃瓜黑料事件与爆料合集
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed mb-8 max-w-xl lg:max-w-none">
              911爆料网作为一站式吃瓜黑料内容聚合入口，每日实时追踪全网热点爆料事件，覆盖娱乐八卦、社会黑料、网红翻车等热门话题。我们以最快的速度整理911吃瓜黑料最新合集，提供视频、图文、时间线等多维度内容，让你不错过任何一个瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">200+</div>
                <div className="text-xs text-background-50/50 mt-1">每日更新条目</div>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">50万+</div>
                <div className="text-xs text-background-50/50 mt-1">月活吃瓜用户</div>
              </div>
              <div className="w-px h-10 bg-background-50/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400">7×24h</div>
                <div className="text-xs text-background-50/50 mt-1">全天候实时追踪</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-bold bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center animate-pulse-glow"
              >
                立即吃瓜
              </a>
              <a
                href="#carousel"
                className="w-full sm:w-auto px-8 py-3.5 text-base font-medium text-background-50 border border-background-50/30 rounded-md hover:bg-background-50/10 transition-colors duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                焦点专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:flex hidden">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20conceptual%203D%20illustration%20of%20a%20glowing%20hot%20news%20aggregation%20hub%2C%20floating%20cards%20with%20warm%20crimson%20and%20gold%20accents%2C%20digital%20information%20network%20visualization%2C%20dark%20elegant%20background%2C%20modern%20editorial%20design%2C%20abstract%20geometric%20shapes%2C%20professional%20news%20media%20aesthetic&width=1200&height=900&seq=hero-main-911&orientation=landscape"
                alt="911爆料网 - 吃瓜黑料内容聚合平台视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex gap-2 flex-wrap">
                  <span className="px-3 py-1 text-xs font-medium bg-primary-500/80 backdrop-blur-sm text-background-50 rounded-full whitespace-nowrap">
                    今日最热
                  </span>
                  <span className="px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full whitespace-nowrap">
                    实时追踪
                  </span>
                  <span className="px-3 py-1 text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full whitespace-nowrap">
                    全网首发
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}